import { render, staticRenderFns } from "./orderTable.vue?vue&type=template&id=0874a5ac&scoped=true"
import script from "./orderTable.vue?vue&type=script&lang=js"
export * from "./orderTable.vue?vue&type=script&lang=js"
import style0 from "./orderTable.vue?vue&type=style&index=0&id=0874a5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874a5ac",
  null
  
)

export default component.exports